/**
 * Shown wherever an account is created (web sign-up, the native sign-up sheet).
 * Every new account is opted into product-update emails, and the API records
 * this wording's version with that opt-in: change the copy here and bump
 * SIGNUP_EMAIL_NOTICE_VERSION (api notificationPreferenceService) with it.
 */
export const SIGNUP_EMAIL_NOTICE =
  "We'll email you occasional product updates. Opt out any time in settings.";
